import { z } from "zod";

export const HELP_CATEGORIES = [
  "DOWNLOAD_EXPORT",
  "PAYMENT",
  "ACCOUNT_SECURITY",
  "AI_FEATURE",
  "OTHER",
] as const;

export const HelpCategorySchema = z.enum(HELP_CATEGORIES);
export type HelpCategory = (typeof HELP_CATEGORIES)[number];

/** Création d'une demande d'aide (utilisateur connecté). */
export const CreateHelpRequestDtoSchema = z.object({
  category: HelpCategorySchema,
  /**
   * Le sujet est OPTIONNEL : il est déduit du thème choisi et de la
   * première phrase du message côté serveur — l'utilisateur ne doit
   * jamais avoir à « titrer » sa demande après avoir choisi un thème.
   */
  subject: z
    .string()
    .min(3, "Le sujet doit faire au moins 3 caractères")
    .max(120, "Le sujet est trop long")
    .optional(),
  message: z
    .string()
    .min(10, "Décrivez votre problème (10 caractères minimum)")
    .max(4000, "Message trop long (4000 max)"),
  /** Contexte client auto-attaché, optionnel. */
  context: z.record(z.string(), z.unknown()).optional().default({}),
});
export type CreateHelpRequestDto = z.infer<typeof CreateHelpRequestDtoSchema>;

/** Réponse / nouveau message (utilisateur OU admin). */
export const CreateHelpMessageDtoSchema = z.object({
  body: z.string().min(1, "Message vide").max(4000, "Message trop long (4000 max)"),
  internalNote: z.boolean().optional().default(false),
});
export type CreateHelpMessageDto = z.infer<typeof CreateHelpMessageDtoSchema>;

/** Mise à jour du statut (admin). */
export const UpdateHelpStatusDtoSchema = z.object({
  status: z.enum(["OPEN", "IN_PROGRESS", "RESOLVED", "CLOSED"]),
});
export type UpdateHelpStatusDto = z.infer<typeof UpdateHelpStatusDtoSchema>;

/** Assignation (admin). */
export const AssignHelpDtoSchema = z.object({
  adminId: z.string().optional().nullable(),
});
export type AssignHelpDto = z.infer<typeof AssignHelpDtoSchema>;
